module.exports = __webpack_public_path__ + "images/EarnPointCard2_906ffea.png";